module.exports = "https://static.wmbcdn.com/uniweb/images/ddeed1476511bbc459a95d8122f571a7.svg";